import { Controller } from "@hotwired/stimulus"

// Enables/disables the "Corrección manual" link based on checked checkboxes
// and dynamically builds the URL with selected fields as query params.
export default class extends Controller {
  static targets = ["checkbox", "link"]
  static values = { baseUrl: String }

  validate() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    const anyChecked = checked.length > 0

    if (anyChecked) {
      const params = checked.map(cb => `fields[]=${encodeURIComponent(cb.value)}`).join("&")
      this.linkTarget.href = `${this.baseUrlValue}?${params}`
      this.linkTarget.style.pointerEvents = ""
      this.linkTarget.style.opacity = ""
    } else {
      this.linkTarget.removeAttribute("href")
      this.linkTarget.style.pointerEvents = "none"
      this.linkTarget.style.opacity = "0.5"
    }
  }
}
